import { Button } from "@swivl-mono/ui";
import AccountModel from "../../../Models/Account/AccountModel";
import { UpdatePasswordComponent } from "./Components/UpdatePassword.Component";

export function AccountSettingsView() {
  const { account } = AccountModel.useState(s => s);
  return (
    <div className="flex flex-col overflow-y-auto p-5">
      <div className="flex flex-row">
        <h1 className="flex-1"></h1>
        <Button onClick={AccountModel.logOut}>Logout</Button>
      </div>
      {account?.email}
      <UpdatePasswordComponent />
    </div>
  )
}
